<div [formGroup]="form">
    <mat-label class="font-style" [ngbTooltip]="gasketCompThickness_tooltip" placement="right" container="body" tooltipClass="small-tooltip">
        <!-- Gasket Comp Thickness -->
        {{ 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT.GAKSET_COMP_THICKNESS' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #gasketCompThickness_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.GASKET_COMP_THICKNESS' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->

    <input
        matInput
        class="input-form-class"
        formControlName="gasketCompThickness"
        name="gasketCompThickness"
        [ngClass]="form.get('gasketCompThickness').valid ? '' : 'highLight'"
    />
</div>
